import { SvgIcon } from '@mui/material';

export function HomeStorageIcon(props) {
	return (
		<SvgIcon
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			{...props}
		>
			<path
				d="M5.30775 20.5C4.80258 20.5 4.375 20.325 4.025 19.975C3.675 19.625 3.5 19.1974 3.5 18.6923V5.30775C3.5 4.80258 3.675 4.375 4.025 4.025C4.375 3.675 4.80258 3.5 5.30775 3.5H18.6923C19.1974 3.5 19.625 3.675 19.975 4.025C20.325 4.375 20.5 4.80258 20.5 5.30775V18.6923C20.5 19.1974 20.325 19.625 19.975 19.975C19.625 20.325 19.1974 20.5 18.6923 20.5H5.30775ZM5.30775 19H18.6923C18.7821 19 18.8558 18.9712 18.9135 18.9135C18.9712 18.8558 19 18.7821 19 18.6923V15.8077H15.7115C15.2757 16.4411 14.7343 16.9327 14.0875 17.2828C13.4407 17.6328 12.7448 17.8077 12 17.8077C11.2552 17.8077 10.5593 17.6328 9.9125 17.2828C9.26567 16.9327 8.72433 16.4411 8.2885 15.8077H5V18.6923C5 18.7821 5.02883 18.8558 5.0865 18.9135C5.14417 18.9712 5.21792 19 5.30775 19ZM12 16.3077C12.6333 16.3077 13.2083 16.1244 13.725 15.7578C14.2417 15.3911 14.6 14.9078 14.8 14.3077H19V5.30775C19 5.21792 18.9712 5.14417 18.9135 5.0865C18.8558 5.02883 18.7821 5 18.6923 5H5.30775C5.21792 5 5.14417 5.02883 5.0865 5.0865C5.02883 5.14417 5 5.21792 5 5.30775V14.3077H9.2C9.4 14.9078 9.75833 15.3911 10.275 15.7578C10.7917 16.1244 11.3667 16.3077 12 16.3077ZM5.30775 19H5H19H5.30775ZM7.25 12.077H16.75V10.577H7.25V12.077ZM7.25 8.7885H16.75V7.2885H7.25V8.7885Z"
				fill="currentColor"
			/>
		</SvgIcon>
	);
}
